import { render, staticRenderFns } from "./SaleInvoicesRetentionListFiltersForm.vue?vue&type=template&id=60ead6d7&scoped=true&"
import script from "./SaleInvoicesRetentionListFiltersForm.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesRetentionListFiltersForm.vue?vue&type=script&lang=js&"
import style0 from "./SaleInvoicesRetentionListFiltersForm.vue?vue&type=style&index=0&id=60ead6d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ead6d7",
  null
  
)

export default component.exports